import type {TreePayload} from '@github-ui/code-view-types'
import React from 'react'

const TreeContext = React.createContext({} as TreePayload)

export function useCurrentTree() {
  return React.use(TreeContext)
}

export function CurrentTreeProvider({payload, children}: React.PropsWithChildren<{payload: TreePayload}>) {
  return <TreeContext value={payload}>{children}</TreeContext>
}
